<template>
  <div class="admin">
    <h2>GameWeeks</h2>
    <v-expansion-panels>
      <game-week-panel
        v-for="gameWeek in gameWeeks"
        :key="gameWeek.number"
        :game-week="gameWeek"
        @gameWeekUpdate="gameWeekUpdate($event)"
      />
    </v-expansion-panels>
  </div>
</template>

<script>
import GameWeekService from '@/services/gameWeek.service.js'
import GameWeekPanel from '@/components/Admin/GameWeekPanel.vue'

export default {
  components: {
    GameWeekPanel,
  },
  data() {
    return {
      gameWeeks: [],
      gamesByWeek: [],
    };
  },
  mounted() {
    GameWeekService.getGameWeeks().then((gameWeeks) => {
      this.gameWeeks = gameWeeks;
    });
  },
  methods: {
    gameWeekUpdate(newGameWeek) {
      const index = this.gameWeeks.findIndex(item => item.number === newGameWeek.number);

      if (index !== -1) {
        this.gameWeeks[index] = newGameWeek;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.admin {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1200px;
  margin: auto;
}
</style>
